/* eslint-disable prefer-destructuring */
import store from '../../../../configureStore';
import { TAppState } from '../../../../reducers';
import { hexToRGBATuple } from '../../../../common/colorUtils';

const parseBrandingColors = () => {
    const { getState, subscribe }: { getState: () => TAppState; subscribe: any } = store;

    let colors!: string;

    const getStateFromStore = () => {
        // @ts-ignore property does not exist on type 'never'
        colors = getState().session.user.customization.colors;
    };

    subscribe(() => getStateFromStore);
    getStateFromStore();

    const brandColorsFromProps = JSON.parse(colors).filter((item: any) =>
        Object.prototype.hasOwnProperty.call(item, 'color')
    );

    // Adds key to name as the sdk requires names to be unique
    const brandingColors = brandColorsFromProps.length
        ? brandColorsFromProps.map((item: any, key: number) => ({
              color: hexToRGBATuple(item.color),
              name: `${key}-${item.title}`,
          }))
        : [];

    return brandingColors;
};

export default parseBrandingColors;
